import { useCursorHandlers } from '../../../contexts/CursorContext/Cursor';
import { useTheme } from '@mui/material/styles';

export const useEditorHandlers = (name: string) => {
  const theme = useTheme();

  return useCursorHandlers({
    name,
    styles: [
      {
        name: 'theme_component_drawer_background_color',
        label: 'Background color',
        type: 'color',
        default: theme.palette.primary.light,
      },
      {
        name: 'theme_component_drawer_background_image',
        label: 'Background image',
        type: 'text',
        startAdornment: 'url(https://',
        endAdornment: '/)',
      },
      {
        name: 'theme_component_drawer_background_position',
        label: 'Background position',
        type: 'select',
        default: 'center',
        options: ['top', 'right', 'bottom', 'left', 'center'],
      },
      {
        name: 'theme_component_drawer_background_size',
        label: 'Background size',
        type: 'select',
        default: 'cover',
        options: ['cover', 'contain', 'initial', 'inherit', 'auto'],
      },
      {
        name: 'theme_component_drawer_background_repeat',
        label: 'Background repeat',
        type: 'select',
        default: 'no-repeat',
        options: ['no-repeat', 'repeat-y', 'repeat-x', 'repeat'],
      },
    ],
    configuration: [],
  });
}